import { axios as client } from './apiAdmin'
import { exportFile } from '../requestDownloadFile'
export const sellerLogsApi = {
  // 获取商家近 30 天的广告活动聚合报表
  getSellerBrandChangeLogs: data => {
    return client.get('seller/task/brand-change-logs', { params: data }).then(res => res)
  },
  // 导出商家近 30 天的广告活动聚合报表
  exportSellerBrandChangeLogs: data => {
    return exportFile('seller/task/brand-change-logs/export', data.qs, data.fileName, data.platform)
  },
  // 获取商家近 30 天的广告活动聚合报表
  getSellerProductChangeLogs: data => {
    return client.get('seller/task/product-change-logs', { params: data }).then(res => res)
  },
  // 导出商家近 30 天的广告活动聚合报表
  exportSellerProductChangeLogs: data => {
    return exportFile('seller/task/product-change-logs/export', data.qs, data.fileName, data.platform)
  },
  // 获取商家近 30 天的广告活动聚合报表
  getSellerPartnershipChangeLogs: data => {
    return client.get('seller/task/partnership-change-logs', { params: data }).then(res => res)
  },
  // 导出商家近 30 天的广告活动聚合报表
  exportSellerPartnershipChangeLogs: data => {
    return exportFile('seller/task/partnership-change-logs/export', data.qs, data.fileName, data.platform)
  },
  // 获取商家近 30 天的广告活动聚合报表
  getSellerAssociateReportBatchList: data => {
    return client.get('associate/report/batch/list', { params: data }).then(res => res)
  },
  // 重新清洗关联报告批次
  cleanSellerAssociateReportBatch: data => {
    return client.post(`associate/report/batch/${data.id}/re-clean`, data).then(res => res)
  },
}